module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/IceDay/Tokyo_IceDay_MRI_RCP85_End.png";